export default __webpack_public_path__ + "static/media/christmasLogoSingle.3cb47c28.svg";